// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"154":"59e10e9b","493":"083ca685","619":"b40bc2c6","823":"9d515ae8"}[chunkId] + ".chunk.js";
};